import styled from "styled-components";

export const Container = styled.div`
  width: "404px";
`;

export const StyledElementContainer = styled.div`
  text-align: right;
  display: ${(props) => {
    if (props.display === "horizontal" || props.display === "vertical") {
      return "flex";
    }
  }};
  justify-content: ${(props) => {
    if (props.display === "horizontal" || props.display === "vertical") {
      return "end";
    }
  }};
  flex-direction: ${(props) => {
    if (props.display === "horizontal") {
      return "row";
    } else if (props.display === "vertical") {
      return "column";
    }
  }};
`;

export const CaptionContainer = styled.div`
  font-size: 16px;
  font-family: Yekan-Bakh-Regular;
  direction: rtl;
  text-align: right;
  margin-bottom: 10px;
`;
